import React, { useMemo } from 'react';
import { renderMarkdown } from '../utils/markdown';
import './MarkdownContent.css';

/** 出团通知书段落内容：按 Markdown 渲染，样式与服务端 PDF（noticeHtmlBuilder MARKDOWN_CSS）一致 */
const MarkdownContent = ({ text, style }) => {
  const html = useMemo(() => renderMarkdown(text), [text]);
  if (!html) return null;
  return <div className="notice-md" style={style} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default MarkdownContent;
